<!-- 안전리더십 > 과제설정 > 모니터링형식설정 팝업 -->
<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="94rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.monitoringFormatSetting')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <v-card-text class="ty01">
          <div class="form-group col-ty">
            <!--form-row-->
            <div class="form-row ty03">
              <div class="txt-tit ty04">{{t('message.type')}}</div>
              <div class="row">
                <div class="txt">{{popupItem.contentType == '3'?t('message.selfMonitoring'):t('message.peerMonitoring')}}</div>
              </div>
            </div>
            <!--form-row-->
            <div class="form-row ty05" v-if="popupItem.contentType == '4'">
              <div class="txt-tit ty04">{{t('message.targetRole')}}</div>
              <div class="row">
                <Select v-bind="monitoringTypeSelect" v-model="viewInfo.monitoringType"/></div>
                <!-- <c-btnText01 :btnText="'피관찰자팝업 퍼블(개발후삭제)'" style="margin-left:2rem" @click="dialogOtherTargetType2Model=true"/> -->
            </div>
            <div class="form-row ty05" v-if="popupItem.contentType == '4'">
              <div class="txt-tit ty04">{{viewInfo.monitoringType == '1'?t('message.observee'):t('message.observer')}}</div>
              <div class="row">
                <c-btn01 :btnText="t('message.update')" class="sm" @click="onClickOtherMember"/>
                <v-btn class="txt03">{{viewInfo.targetList?viewInfo.targetList?.length:'0'}}{{t('message.countPerson')}}</v-btn>
              </div>
            </div>
          </div>
          <div class="sort-group ty02">
            <div class="sort-row">
              <div class="wl">
                <div class="txt04">{{t('message.overall')}} {{viewInfo.behaviorList?viewInfo.behaviorList.length:'0'}}{{t('message.count')}}</div>
              </div>
              <div class="wr">
                <c-btn02 :btnText="t('message.loadData')" class="sm" @click="onClickBehavior"/>
                <!-- <c-btn01 :btnText="t('message.add')" class="sm" @click="onClickMoveBehavior"/> -->
              </div>
            </div>
          </div>
          <div class="sortable-group02">
            <div class="sortable-header">
              <div class="col" v-html="t('message.displayOrderLeadership')"></div>
              <div class="col">{{t('message.title')}}</div>
              <div class="col">{{t('message.type')}}</div>
              <div class="col">{{t('message.delete')}}</div>
            </div>
            <draggable
              v-model="viewInfo.behaviorList"
              item-key="idx"
              tag="div"
              class="sortable-cont"
              animation="200"
              @end="onChange"
            >
              <template #item="{element, index}">
                <div class="draggable" :key="element.idx">
                  <div class="row">
                    <div class="col" aria-hidden="true">
                      <img src="../../assets/img/format-align-justify.svg" alt="">
                    </div>
                    <div class="col">
                      {{ element.behaviorTitle }}
                    </div>
                    <div class="col">
                      {{ behaviorTypeName(element.behaviorType) }}
                    </div>
                    <div class="col">
                      <BtnIcon class="btn-ico-delete" @click="onClickDeleteBehavior(element)"/>
                    </div>
                  </div>
                </div>
              </template>
            </draggable>
          </div>

        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end">
          <c-btn02 :btnText="t('message.cancel')" @click="dialog=false"/>
          <c-btn01 :btnText="t('message.save')" @click="onClickSave"/>
        </v-card-actions>
      </v-card>
      <!--popup: 평가자 리스트-->
      <DialogAppraiserList v-model="dialogOtherTargetType1Model"
                           @close="dialogOtherTargetType1Model=false"
                           @confirm="confirmOtherTarget"
      />
      <!--popup: 행동불러오기-->
      <DialogCallAction v-model="dialogBehaviorModel"
                        @close="dialogBehaviorModel=false"
                        @confirm="confirmBehavior"
                        :pop-title="t('message.loadAction')"
      />
      <!--popup: 피관찰자(타인모니터링) 형식, 사용안함 -->
      <DialogSafetyDetailSetTy1-1 v-model="dialogOtherTargetType2Model"
                        @close="dialogOtherTargetType2Model=false"
      />
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import { storeToRefs } from 'pinia'
import { useCommonStore } from "@/store/common";
import {useForm} from "vee-validate";
import LeadershipService from "@/services/leadership.service";
import utils from "@/common/Utils";
import * as yup from "yup";
import _ from 'lodash';
import draggable from 'vuedraggable'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//validation schema
const schema = yup.object().shape({
})
const { validate } = useForm({ validationSchema: schema })

//bind
const dialogBehaviorModel = ref(false)
const dialogOtherTargetType1Model = ref(false)
const dialogOtherTargetType2Model = ref(false)
const snackbar = ref(false)
const snackText = ref('')
const popupItem:any = storeRef.selectedContent  //선택된 리더십 content
const viewInfo:any = ref({})  //리더십 모니터링정보

//ui
const monitoringTypeSelect = {items: [{name: t('message.observer'), value: '1'}, {name: t('message.observee'), value: '2'}]}

//computed
const behaviorTypeName = computed(()=>(type)=>{
  //1:카운트 2:선택형 3:리커드 4:바 5:다중선택 6:기타
  if(type == '1') return t('message.countType')
  else if(type == '2') return t('message.singleChoiceType2')
  else if(type == '3') return t('message.likertBarsType')
  else if(type == '4') return t('message.barsType')
  else if(type == '5') return t('message.multipleChoiceType')
  else if(type == '6') return t('message.otherType')
})

//hook
onUpdated (() => {
  if (!dialog.value)
    return

  getMonitoring()
})

//function
const getMonitoring = async ()=>{
  try {
    popupItem.value.contentIdx = popupItem.value.idx
    let params={
      contentIdx:popupItem.value.idx,
      leadershipIdx:popupItem.value.leadershipIdx,
      taskIdx:popupItem.value.taskIdx,
      //monitoringType:"1", //관찰자, 피관찰자 의미없을듯
    }
    const response:any = await LeadershipService.getLeadershipMonitoring(params)
    viewInfo.value = response.result
  }
  catch (error) {
    if(error.status == 403)
      utils.movePage('/login')
    else
      utils.log(error)
  }
}

const onClickBehavior = ()=>{
  storeRef.popupItems.value = viewInfo.value.behaviorList
  storeRef.moduleType.value = '2'
  dialogBehaviorModel.value=true
}

const confirmBehavior = (params)=>{
  dialogBehaviorModel.value=false
  viewInfo.value.behaviorList = params
}

const onClickMoveBehavior = ()=>{
  window.open('/safetyLeadershipAMList', "_blank")
}

const onClickDeleteBehavior = (item)=>{
  _.remove(viewInfo.value.behaviorList, item)
}
const onClickSave = async()=>{
  try {
    //타인타입인데 타겟없으면 오류
    if(popupItem.value.contentType == '4' && (utils.isEmpty(viewInfo.value.targetList) || viewInfo.value.targetList.length == 0)){
      snackText.value = t('message.pleaseSetMonitoringTarget')
      snackbar.value = true
      return
    }

    const response = await LeadershipService.insertLeadershipMonitoring(JSON.parse(JSON.stringify(viewInfo.value)))
    dialog.value = false
  }
  catch (error) {
    if(error.status == 403)
      utils.movePage('/login')
    else
      utils.log(error)
  }
}

const onClickOtherMember = ()=>{
  //대상역할, 관찰자 피관찰자
  storeRef.popupType.value = viewInfo.value.monitoringType
  //모니터링 전체정보
  storeRef.leadershipMonitoringInfo.value = viewInfo.value
  dialogOtherTargetType1Model.value=true
}

const confirmOtherTarget=(list)=>{
  viewInfo.value.targetList = list
}

const onChange = () => {
  console.log('최종 순서:', viewInfo.value.behaviorList.map(v => v.idx))
}
</script>


<style lang="scss" scoped>
.sortable-group02{
  .sortable-header ,.sortable-cont .draggable{
    .col:nth-child(1){flex-grow:0;width:5%;}
    .col:nth-child(2){justify-content:flex-start;text-align:left;width:70%;}
    .col:nth-child(3){flex-grow:0;width:15%;}
    .col:nth-child(4){flex-grow:0;width:10%;}
  }
}
</style>
